import { createSelector } from 'reselect';
import { ascend, descend, filter, prop as rProp, slice, sortWith } from 'ramda';

import { createFilter } from './FilterUtil';

const getUsers = state => state.entities.users.items;
const getUsersFilter = state => state.entities.users.filter;
const getUsersPagination = state => state.entities.users.pagination;

const userMatchesFilter = (u, filterValue) =>
  !filterValue ||
  (u.firstName && u.firstName.indexOf(filterValue) > -1) ||
  (u.lastName && u.lastName.indexOf(filterValue) > -1) ||
  (u.email && u.email.indexOf(filterValue) > -1) ||
  (filter(a => a.indexOf(filterValue) > -1, u.authorities).length > 0);

const getUsersFiltered = createSelector([getUsers, getUsersFilter], (users, filterValue) =>
  filterValue
    ? filter(createFilter(filterValue, userMatchesFilter), users)
    : users
);

export const getUsersFilteredPage = createSelector(
  [getUsersFiltered, getUsersPagination],
  (filtered, { page, size }) => {
    const sorted = sortWith(
      [ascend(rProp('lastName')), ascend(rProp('firstName')), ascend(rProp('email')), descend(rProp('id'))],
      filtered
    );
    return {
      items: slice(page * size, (page + 1) * size, sorted),
      page: page,
      size: size,
      totalSize: sorted.length
    };
  }
);



// WEBPACK FOOTER //
// ./src/selectors/UsersSelector.js